import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.match";
import "core-js/modules/es.string.search";
import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { useLanguage } from '../useLanguage';
import { useSetLanguage } from '../useSetLanguage';

function LocalizedRoute(_ref) {
  var children = _ref.children,
      match = _ref.match,
      location = _ref.location;
  var pathname = location.pathname,
      search = location.search;

  var _useLanguage = useLanguage(),
      currentLang = _useLanguage.currentLang,
      allLangs = _useLanguage.allLangs;

  useSetLanguage({
    lang: match.params.lang
  });

  var insertLang = function insertLang(paramsLang) {
    return allLangs && paramsLang && !allLangs.includes(paramsLang);
  };

  if (insertLang(match.params.lang)) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/".concat(currentLang).concat(pathname).concat(search)
    });
  }

  if (currentLang !== match.params.lang) {
    return null;
  }

  return children;
}

export default LocalizedRoute;